/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

const showInfinity = value => {
    if ( value >= 99999 ) return 'Infinite';
    return value;
};

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const totalCapValueGetter = params => {

    if ( params.data.recordCount === 0 ) return 'Infinite Availability';

    return params.data.totalCapacity;

};

const colDefs = [
    {
        field: 'bundleCode',
        headerName: 'Bundle Code',
        sortable: false,
        filter: false,
        width: 100
    },
    {
        field: 'weekNumber',
        headerName: 'Week',
        sortable: true,
        filter: true,
        width: 80,
        colSpan: function ( params ) {

            if ( formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' ) === '2000-01-01' || formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' ) === '2000-02-01' ) {

                return ( 3 );

            }
            return 1;

        },
        cellRenderer: params => {

            if ( formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' ) === '2000-01-01' ) return ( <span>Inventory</span> );
            if ( formatGivenDate( params.data.weekEnding, 'YYYY-MM-DD' ) === '2000-02-01' ) return ( <span>Rework</span> );
            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'weekEnding',
        headerName: 'Ending',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'fiscalMonthName',
        headerName: 'Month',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        headerName: 'Total Cap',
        sortable: true,
        width: 80,
        valueGetter: totalCapValueGetter,
        colSpan: function ( params ) {

            if ( params.data.recordCount === 0 ) {

                return ( params.data.reportType === 'Bundle' ? 6 : 5 );

            }
            return 1;

        }
    },
    {
        field: 'totalAvailabilty',
        headerName: 'Total Availability',
        sortable: true,
        width: 120,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'runningAvailability',
        headerName: 'Running Availability',
        sortable: true,
        width: 140,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'maxQty',
        headerName: 'Maximum',
        sortable: true,
        width: 90,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'forecastQty',
        headerName: 'Forecast',
        sortable: true,
        width: 90,
        valueFormatter: params => showInfinity( params.value )
    },
    {
        field: 'flexQty',
        headerName: 'Flex Qty',
        sortable: true,
        width: 100,
        valueFormatter: params => showInfinity( params.value )
    }, {
        field: 'totalOrdered',
        headerName: 'Total Ordered',
        sortable: true,
        // filter: true,
        width: 110,
        valueFormatter: params => showInfinity( params.value ),
        cellRenderer: params => {

            if ( params.value === 0 ) return ( <span>{params.valueFormatted}</span> );
            return ( <Link to={`/constraints/check-orders-by-constraint-build-week?constarainttype=${params.data.ctype}&constarintkey=${params.data.ckey}&weekending=${params.data.weekEnding}`}>{params.valueFormatted}</Link> );

        }
    }
];

const NoBundlesOrderedTable = props => (

    <section className="atp-search-result-panel no-bundles-ordered-result-panel ">

        <div className="results-message">
            {`No Bundles Ordered as of ${new Date()}` }
        </div>

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

NoBundlesOrderedTable.propTypes = {
    results: PropTypes.array.isRequired,
    time: PropTypes.number,
    oaKey: PropTypes.string
};
export default NoBundlesOrderedTable;
